import { MATRIMONIALURL } from "helpers/constant";
import { callApi } from "Apis";
import { encryptId } from "helpers/cryptography";
import { PLAIN_TEXT } from "helpers/constant";

export async function getMatrimonialListApi(data) {
  try {
    const response = await callApi({ url: MATRIMONIALURL.LIST, body: data, method: "POST" });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addMatrimonialApi(data) {
  try {
    const response = await callApi({ url: MATRIMONIALURL.ADD, body: data, method: "POST" });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getMatrimonialDataByIdApi(id) {
  try {
    const response = await callApi({ url: MATRIMONIALURL.GET(id), method: "GET" });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateMatrimonialDataApi(data) {
  try {
    const response = await callApi({ url: MATRIMONIALURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteMatrimonialDataApi(id) {
  try {
    const response = await callApi({ url: MATRIMONIALURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function verifyMatrimonialDataApi(id) {
  try {
    const encryptedId = PLAIN_TEXT ? id : encryptId(id);
    const response = await callApi({ url: MATRIMONIALURL.VERIFY(encryptedId), method: "PUT" });
    return response;
  } catch (error) {
    throw error;
  }
}
